import { PROMO_ICON } from '../../constants/promoIcon';
import { IPromo } from '../../types/newbuilding/promos';

export const getPromoIcon = (promo?: IPromo) => {
  if (promo == null) {
    return null;
  }

  const { isFromBank, bank, promoType } = promo;

  return isFromBank && bank ? bank.secondSquareImageUrl || bank.logoUrl : PROMO_ICON.get(promoType);
};
